import { has, reduce, forEach, find, includes } from "lodash";

import { upsertOption } from "~/utilities/reducer";

export const getPresetFormValues = (formInformation, presets) => {
    if (formInformation?.formFields?.nodes?.length) {
        return reduce(
            formInformation.formFields.nodes,
            (acc, curr) => {
                let currentFields = acc;

                if (!curr.inputName && !curr.adminLabel) {
                    return currentFields;
                }

                const inputName = `input_${curr.databaseId}`;

                if (!curr.inputName && curr.adminLabel) {
                    if (has(presets, curr.adminLabel)) {
                        currentFields = upsertOption(currentFields, {
                            [inputName]: presets[curr.adminLabel],
                        });
                    }

                    return currentFields;
                }

                if (has(presets, curr.inputName)) {
                    currentFields = upsertOption(currentFields, {
                        [inputName]: presets[curr.inputName],
                    });
                }

                return currentFields;
            },
            {},
        );
    }
};

const updateFormDataByCssClass = (formInformation, presets, customizers) => {
    return reduce(
        formInformation.formFields.nodes,
        (acc, curr) => {
            let newField = curr;

            if (!curr.cssClass) {
                return acc.concat(newField);
            }

            const runCustomizer = () => {
                forEach(customizers, ({ cssClass, fieldUpdates }) => {
                    const fieldToCheck =
                        newField.inputName ?? newField.adminLabel;
                    if (
                        includes(newField.cssClass, cssClass) &&
                        has(presets, fieldToCheck)
                    ) {
                        newField = {
                            ...newField,
                            ...fieldUpdates,
                        };
                    }
                });
            };

            if (!curr.inputName && !curr.adminLabel) {
                return acc.concat(newField);
            }

            runCustomizer();
            return acc.concat(newField);
        },
        [],
    );
};

export const prepareFormData = (formInformation, presets) => {
    let data = formInformation;

    if (formInformation?.formFields?.nodes?.length) {
        const customizers = [
            {
                cssClass: "gf_readonly",
                fieldUpdates: {
                    readonly: true,
                },
            },
        ];

        const updatedFormFields = updateFormDataByCssClass(
            formInformation,
            presets,
            customizers,
        );

        data.formFields.nodes = updatedFormFields ?? data.formFields.nodes;
    }

    return data;
};

export const addHiddenValuesToPresets = (
    formInformation,
    originalPresets,
    hiddenPresets,
    isRma,
) => {
    if (formInformation?.formFields?.nodes?.length) {
        const formattedHiddenPresets = reduce(
            formInformation.formFields.nodes,
            (acc, curr) => {
                if (
                    (!includes(curr.cssClass, "hide_if_case") && isRma) ||
                    (!curr.inputName && !curr.adminLabel)
                ) {
                    return acc;
                }

                const hiddenObj = find(
                    hiddenPresets,
                    ({ id }) => id === curr.databaseId,
                );

                if (!curr.inputName && curr.adminLabel) {
                    if (hiddenObj) {
                        acc[curr.adminLabel] = hiddenObj.emailValues.value;
                    }
                    return acc;
                }

                if (hiddenObj) {
                    acc[curr.inputName] = hiddenObj.value;
                    return acc;
                }

                return acc;
            },
            {},
        );

        return {
            ...formattedHiddenPresets,
            ...originalPresets,
        };
    }

    return originalPresets;
};
